import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";


export default function PerfilGasesSalidaCPC() {
  const [flujosSolidosSCPC, setFlujosSolidosSCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [caudalGasSCPC, setCaudalGasSCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeN2SCPC, setPorcentajeN2SCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentaje02SCPC, setPorcentaje02SCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeH20SCPC, setPorcentajeH20SCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS2SCPC, setPorcentajeS2SCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS02SCPC, setPorcentajeS02SCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs2S3SCPC, setPorcentajeAs2S3SCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs4O6SCPC, setPorcentajeAs4O6SCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 37,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateFlujosSolidosSCPC(data);
    populateCaudalGasSCPC(data);
    populatePorcentajen2SCPC(data);
    populatePorcentaje02SCPC(data);
    populatePorcentajeH20SCPC(data);
    populatePorcentajeS2SCPC(data);
    populatePorcentajeS02SCPC(data);
    populatePorcentajeAs2S3SCPC(data);
    populatePorcentajeAs4O6SCPC(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateFlujosSolidosSCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Sólidos Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFlujosSolidosSCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalGasSCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Caudal de Gas Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCaudalGasSCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajen2SCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%N2 Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeN2SCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentaje02SCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%O2 Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentaje02SCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeH20SCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%H2O Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeH20SCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS2SCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%S2 Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS2SCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS02SCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%SO2 Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS02SCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs2S3SCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As2S3 Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs2S3SCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs4O6SCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As4O6 Salida CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs4O6SCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil de Gases Salida CPC"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Flujo de Sólidos Salida CPC --------------------------------------- */}
            <Chart.Line
              name="Flujo de Sólidos Salida CPC"
              data={flujosSolidosSCPC.value}
              yAxis={0}
            />
            {/** -------------------------------- Caudal de Gas Salida CPC --------------------------------------- */}
            <Chart.Line
              name="Caudal de Gas Salida CPC"
              data={caudalGasSCPC.value}
              yAxis={0}
            />
            {/** -------------------------------- %N2 Salida CPC --------------------------------------- */}
            <Chart.Line
              name="%N2 Salida CPC"
              data={porcentajeN2SCPC.value}
              yAxis={1}
            />
            {/** -------------------------------- %O2 Salida CPC --------------------------------------- */}
            <Chart.Line
              name="%O2 Salida CPC"
              data={porcentaje02SCPC.value}
              yAxis={1}
            />
            {/** -------------------------------- %H2O Salida CPC --------------------------------------- */}
            <Chart.Line
              name="%H2O Salida CPC"
              data={porcentajeH20SCPC.value}
              yAxis={1}
            />
            {/** -------------------------------- %S2 Salida CPC --------------------------------------- */}
            <Chart.Line
              name="%S2 Salida CPC"
              data={porcentajeS2SCPC.value}
              yAxis={1}
            />
            {/** -------------------------------- %SO2 Salida CPC --------------------------------------- */}
            <Chart.Line
              name="%SO2 Salida CPC"
              data={porcentajeS02SCPC.value}
              yAxis={1}
            />
            {/** -------------------------------- %As2S3 Salida CPC --------------------------------------- */}
            <Chart.Line
              name="%As2S3 Salida CPC"
              data={porcentajeAs2S3SCPC.value}
              yAxis={1}
            />
            {/** -------------------------------- %As4O6 Salida CPC --------------------------------------- */}
            <Chart.Line
              name="%As4O6 Salida CPC"
              data={porcentajeAs4O6SCPC.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujosSolidosSCPC.fecha} />

            <Chart.YAxis
              labelSuffix=" Nm3/h"
              title="Caudal de Gases, Nm3/h"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={80000}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={80}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
